/** @format */

import {Table, TableCell, TableRow} from '@mui/material';
import {Trans} from 'react-i18next';

import {StyledTableBody, StyledTableContainer, StyledTableHead} from '../../styles';
import {NotFoundPagesTableProps} from './interfaces';

const NotFoundPagesTable = ({data}: NotFoundPagesTableProps) => (
  <StyledTableContainer>
    <Table>
      <StyledTableHead>
        <TableRow>
          <TableCell>
            <Trans>Субаккаунт</Trans>
          </TableCell>
          <TableCell>
            <Trans>ID Кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>Название кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>Тип ссылки</Trans>
          </TableCell>
          <TableCell>
            <Trans>Ссылка</Trans>
          </TableCell>
        </TableRow>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.subAccount}</TableCell>
            <TableCell>{row.campaignId}</TableCell>
            <TableCell>{row.campaignName}</TableCell>
            <TableCell>{row.linkType}</TableCell>
            <TableCell>{row.link}</TableCell>
          </TableRow>
        ))}
      </StyledTableBody>
    </Table>
  </StyledTableContainer>
);

export default NotFoundPagesTable;
